<template>
  <div id="app" class="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import autofit from 'autofit.js'
export default {
  name: 'App',
  mounted () {
    autofit.init({
      designHeight: 1080,
      designWidth: 1920,
      renderDom: '#app',
      resize: true
    })
    // 每6秒刷新一次页面
    setInterval(() => {
      this.reload()
    }, 600000)
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.app {
  width: 100%;
  height: 100vh;
  background: url("./assets/imgs/delall.png") no-repeat;
  background-size: 100% 100%;
  padding: 10px;
}
</style>
